// extracted by mini-css-extract-plugin
module.exports = {"advantage":"styles_advantage__3oCdx","img_wrap":"styles_img_wrap__1q-bv","title":"styles_title__32X2L","text":"styles_text__2yY64"};